import LineNightIcon from 'LuxKit/Icons/line/LineNightIcon'
import SolidNightIcon from 'LuxKit/Icons/solid/SolidNightIcon'
import { setSvgIconSize } from 'LuxKit/SvgIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React, { ReactElement } from 'react'
import styled from 'styled-components'

const Container = styled(Group)`
  padding: ${rem(4)};
  height: ${rem(24)};
  min-width: ${rem(24)};
  flex-shrink: 0;
  border-radius: ${props => props.theme.borderRadius.round};
  border: 1px solid transparent;
  ${setSvgIconSize(16)}

  ${mediaQueryUp.tablet} {
    padding: ${rem(8)};
    height: ${rem(40)};
    min-width: ${rem(40)};
    ${setSvgIconSize(24)}
  }

  &.state-initial {
    background-color: ${props => props.theme.palette.neutral.default.seven};
    color: ${props => props.theme.palette.neutral.default.one};
  }
  &.state-pending {
    background-color: ${props => props.theme.palette.neutral.default.seven};
    color: ${props => props.theme.palette.neutral.default.one};
    border-color: ${props => props.theme.palette.neutral.default.one};
    border-style: dashed;
  }
  &.state-active {
    background-color: ${props => props.theme.palette.neutral.default.two};
    color: ${props => props.theme.palette.neutral.default.eight};
  }
`

interface Props {
  state: 'initial' | 'pending' | 'active'
  caption?: ReactElement | string
}

function LoyaltyNightsProgressPill({
  state,
  caption,
}: Props) {
  return <Container
    className={`state-${state}`}
    direction="horizontal"
    gap={8}
    verticalAlign="center"
    horizontalAlign="center"
  >
    {(state === 'initial' || state === 'pending') && <LineNightIcon />}
    {state === 'active' && <SolidNightIcon />}
    {!!caption && <>
      <CSSBreakpoint min="tablet">
        <BodyText variant="medium" weight="bold">{caption}</BodyText>
      </CSSBreakpoint>
      <CSSBreakpoint max="mobile">
        <Caption variant="small" weight="bold" format="uppercase">{caption}</Caption>
      </CSSBreakpoint>
    </>}
  </Container>
}

export default LoyaltyNightsProgressPill
